import React from 'react';
import Layout from '../components/layout';
import SingleFlag from '../components/single-flag';

const FlagPage = () => (
    <Layout>
        <SingleFlag
            name="the original siesta"
            images={[
                '/flags/yellowfiesta/yellowsiesta-1.jpg',
                '/flags/yellowfiesta/yellowsiesta-2.jpg',
                '/flags/yellowfiesta/yellowsiesta-3.png',
                '/flags/yellowfiesta/yellowsiesta-4.jpg',
                '/flags/yellowfiesta/yellowsiesta-5.jpg',
            ]}
            price={180}
        >
            <p>
                120 x 140 CM<br />
                Sed lacinia non quam sed varius.
            </p>

            <p>
                Sed in metus tincidunt, accumsan urna et, hendrerit tellus. Sed posuere nisi a mauris iaculis, non
                consequat risus pretium. Mauris sed lacus nec diam fringilla hendrerit.
            </p>
            <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque quis ex ac sem dignissim volutpat quis
                sed elit. Morbi in ligula fermentum nunc varius tempus a sit amet urna. Sed lacinia non quam sed varius.
                Pellentesque non rhoncus quam, non porta mauris. Phasellus non massa in justo finibus tincidunt.
                Pellentesque ac nisl leo. Vestibulum a ligula eros.
            </p>
        </SingleFlag>
    </Layout>
);

export default FlagPage;
